import React from "react";
import { Badge, BadgeColor, depascalize, LabeledBadge } from "sprint-common-web";

import { RecordType } from "../types/RecordType";

type LabeledRecordTypeBadgeProps = {
    value?: number;
};

export const LabeledRecordTypeBadge = (props: LabeledRecordTypeBadgeProps): JSX.Element => {
    return (
        <LabeledBadge
            label="Record type"
            value={props.value ? RecordType[props.value] : "-"}
            testId="record-type-field"
            badgeSize={14}
            color={mapRecordTypeToBadgeColor(props.value)}
        />
    );
};

export const RecordTypeBadge = (props: { value?: number }): JSX.Element => {
    return (
        <Badge
            color={mapRecordTypeToBadgeColor(props.value)}
            text={props.value ? depascalize(RecordType[props.value]) : "-"}
        />
    );
};

const mapRecordTypeToBadgeColor = (recordType?: RecordType): number => {
    switch (recordType) {
        case RecordType.Video:
            return BadgeColor.LightBlue;
        case RecordType.Audio:
            return BadgeColor.Green;
        case RecordType.Subtitle:
            return BadgeColor.Red;
        default:
            return BadgeColor.Gray;
    }
};
